<template>
  <EditDialog
    v-model:visible="visible"
    :title="
      $t('views.layout.components.MenuList.27637421807257b75afc7d8be03016e7')
    "
    :width="440"
    :padding="32"
    :sure-btn-text="$t('common.120c6514d03ad423f48dd24794ab40ce')"
    :z-index="1001"
    @submit="handleNickName"
  >
    <u-input
      v-model="formModel.nickName"
      :placeholder="
        $t('views.layout.components.MenuList.9b70307b84cecd60b051046fbe5466d6')
      "
      :maxlength="20"
    />
  </EditDialog>
</template>

<script>
import { useI18n } from 'vue-i18n';

import { defineComponent, ref } from 'vue';
import { checkSpace } from '@/libs/reg';
import { message } from '@koi-design/uxd-ui';
import { editUserInfoApi } from '@/api/permission';
import { useStore } from 'vuex';

export default defineComponent({
  setup() {
    const { t } = useI18n();
    const store = useStore();
    const visible = ref(false);
    const formModel = ref({
      nickName: store.getters.botUserInfo?.nickname
    });

    const show = (flag = true) => {
      visible.value = flag;
    };
    const handleNickName = async () => {
      if (!checkSpace(formModel.value.nickName)) {
        message.error(
          t('views.layout.components.MenuList.af8e861f32988d30167df697a9a7595a')
        );
        return;
      }
      const res = await editUserInfoApi(
        {
          nickname: formModel.value.nickName
        },
        store.getters.botUserInfo.userId
      );
      if (res) {
        visible.value = false;
        store.commit('setUserInfo', {
          ...store.state.app.botUserInfo,
          nickname: formModel.value.nickName
        });
        if (store.getters.homelandInfo.role === 'home_owner') {
          store.commit('updateHomelandId', {
            ...store.getters.homelandInfo,
            response_nickname: formModel.value.nickName,
            homeland_owner: formModel.value.nickName
          });
        }
      }
    };
    return {
      show,
      handleNickName,
      formModel,
      visible
    };
  }
});
</script>
